import * as React from 'react';

export function FileSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <title>{'58 file'}</title>
      <path d="M19.949 5.536L16.465 2.05A6.958 6.958 0 0011.515 0H7a5.006 5.006 0 00-5 5v14a5.006 5.006 0 005 5h10a5.006 5.006 0 005-5v-8.515a6.951 6.951 0 00-2.051-4.949zM18.535 6.95A4.983 4.983 0 0119.316 8H15a1 1 0 01-1-1V2.684a5.01 5.01 0 011.051.78zM20 19a3 3 0 01-3 3H7a3 3 0 01-3-3V5a3 3 0 013-3h4.515c.164 0 .323.032.485.047V7a3 3 0 003 3h4.953c.015.162.047.32.047.485z" />
    </svg>
  );
}
